import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";
import { hierarchy } from "d3";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  //padding: ${() => `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.75)}`};
`;
export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;

  border: ${({ error }) =>
    `${viewSizeCalculator(1, true)} solid ${error ? "red" : "#A3A3A3"}`};
  border-radius: ${() => `${viewSizeCalculator(0.9375)}`};
  padding: ${() => `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.75)}`};
  opacity: ${({ disabled }) =>
    disabled ? 0.8 : 1}; /* Reduce opacity when disabled */
  // pointer-events: ${({ disabled }) => disabled ? "none" : "auto"}; /* Prevent interactions when disabled */

  &:focus-within label {
    //top: ${() => `${viewSizeCalculator(-1)}`}; /* Move label up */
    font-size: ${viewSizeCalculator(0.8125)};
    color: #aaa;
  }
  &:focus-within {
    border: ${({ error }) =>
    `${viewSizeCalculator(1, true)} solid ${error ? "red" : "#f96250"}`};
  }
`;

export const FloatingLabel = styled.label`
  position: absolute;
  left: ${viewSizeCalculator(0.75)};
  top: ${viewSizeCalculator(1.3)};
  font-size: ${viewSizeCalculator(0.8125)};
  color: #aaa;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
  padding-bottom: ${viewSizeCalculator(0.5)};
`;

export const Input = styled.input`
  border: none;
  outline: none;
  font-size: ${viewSizeCalculator(1)};
  font-weight: 400;
  width: 100%;
  background-color: transparent;
  height: ${({ height }) =>
    height ? viewSizeCalculator(height) : "fit-content"};
  padding-top: ${viewSizeCalculator(
      0.95,
    )}; /* Adds gap between label and text */

  &:focus + label,
  &:not(:placeholder-shown) + label {
    top: ${viewSizeCalculator(0.5)};
    font-size: ${viewSizeCalculator(0.7)};
    color: #333;
    opacity: 0.9;
  }
  &:disabled {
    cursor: not-allowed;

  }
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  opacity: ${({ disabled }) =>
    disabled ? 0.9 : 1}; 
`;

export const ButtonInput = styled.input`
  border: none;
  outline: none;
  text-align: left;
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem;
  font-weight: 400;
  color: #333;
  // opacity: 75%;
  opacity: ${({ isSelected }) => (isSelected ? 1 : "75%")};
  cursor: pointer;
  // user-select: none;
  width: 90%;
  background-color: transparent;
  height: ${({ height }) =>
    height ? viewSizeCalculator(height) : "fit-content"};
  padding-top: ${viewSizeCalculator(
      0.95,
    )}; /* Adds gap between label and text */

  &:focus + label,
  &:not(:placeholder-shown) + label {
    top: ${viewSizeCalculator(0.5)};
    font-size: ${viewSizeCalculator(0.7)};
    color: #333;
    opacity: 0.5;
  }
`;

export const DropdownButton = styled.button`
  border: none;
  outline: none;
  background-color: transparent;

  transform: rotate(90deg);
  opacity: 50%;
  position: absolute;
  top: ${viewSizeCalculator(1.25)};

  right: ${viewSizeCalculator(0.75)};
  cursor: pointer;
  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`}; // 1.5rem;
    height: ${() => `${viewSizeCalculator(1)}`}; // 1rem;
  }
`;

export const SuggestionsList = styled.ul`
  position: absolute;
  width: 100%;
  height: fit-content;
  background: white;
  border: ${() => `${viewSizeCalculator(1, true)} solid #f2f2f2`};
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  box-shadow:
    0 ${() => `${viewSizeCalculator(0.0625)}`}
      ${() => `${viewSizeCalculator(0.3125)}`} #3333330a,
    0 ${() => `${viewSizeCalculator(0.125)}`}
      ${() => `${viewSizeCalculator(0.625)}`} #33333314,
    0 ${() => `${viewSizeCalculator(0.25)}`}
      ${() => `${viewSizeCalculator(1.25)}`} #3333331f;
  list-style: none;
  top: calc(100% + ${() => `${viewSizeCalculator(0.25)}`});
  left: 0;
  padding: ${() => `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.5)}`};
  z-index: 10;
  overflow: hidden;

  transform-origin: top;
  transform: scaleY(${({ isOpen }) => (isOpen === false ? 0 : 1)});
  opacity: ${({ disabled, isOpen }) => (disabled || isOpen === false ? 0 : 1)};
  visibility: ${({ isOpen }) => (isOpen === false ? "hidden" : "visible")};
  pointer-events: ${({ disabled, isOpen }) =>
    disabled || isOpen === false ? "none" : "auto"};
  transition:
    transform 0.3s ease,
    opacity 0.3s ease,
    visibility 0.3s ease ${({ isOpen }) => (isOpen === false ? "0.3s" : "0s")};

  li {
    padding: ${() => `${viewSizeCalculator(0.7)} ${viewSizeCalculator(1)}`};
    margin-right: ${() => `${viewSizeCalculator(0.3)}`};
    cursor: pointer;
    font-size: ${viewSizeCalculator(1)};
    color: #333333;
    border-radius: ${() => `${viewSizeCalculator(0.625)}`};
    text-overflow: ellipsis;
    text-transform: capitalize !important;

    &:hover {
      background: #f9f9f9;
    }

    &.selected {
      font-weight: 600;
      color: #f96250;
      background: #f6f6f6;
    }

    &.disabled {
      opacity: 0.35;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
`;

export const SuggestionsScroll = styled.div`
  max-height: ${() => `${viewSizeCalculator(15)}`};
  overflow-y: auto;
  /* Stop scroll from chaining to the parent container once the list reaches
     its top/bottom. */
  overscroll-behavior: contain;
  margin-right: ${() => `${viewSizeCalculator(0.3)}`};

  &::-webkit-scrollbar {
    width: ${() => `${viewSizeCalculator(5, true)}`};
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: ${() => `${viewSizeCalculator(4, true)}`};
    margin: ${() => `${viewSizeCalculator(4, true)}`} 0;
  }

  &::-webkit-scrollbar-thumb {
    background: #3333334d;
    border-radius: ${() => `${viewSizeCalculator(4, true)}`};
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #33333380;
  }
`;

export const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${viewSizeCalculator(7)};
`;

export const ClearButton = styled.div`
  position: absolute;
  right: ${viewSizeCalculator(2.25)};
  top: ${viewSizeCalculator(1.05)};
  font-size: ${viewSizeCalculator(0.8125)};
  color: #aaa;
  cursor: pointer;

  &:hover {
    color: #333;
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: ${viewSizeCalculator(0.125)};
  color: red;
  font-size: ${viewSizeCalculator(0.6125)};
  margin-top: 5px;
  margin-left: 2px;
`;
